var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationCircle(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u5716\\u5C64_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 12 12",
    style: {
      enableBackground: "new 0 0 12 12"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#73A29E;}\r\n\t.st1{fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M5.9,11.7c-3.1,0-5.7-2.6-5.7-5.8S2.8,0.2,6,0.2s5.7,2.6,5.7,5.8C11.7,9.2,9.2,11.7,5.9,11.7L5.9,11.7z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M6,0v0.5c3,0,5.4,2.5,5.4,5.5c0,3.1-2.4,5.5-5.5,5.5H5.8C2.9,11.5,0.5,9,0.5,6c0-3.1,2.4-5.5,5.5-5.5V0 M6,0 C2.7,0,0,2.6,0,6c0,3.3,2.6,6,5.9,6c0,0,0,0,0.1,0c3.4,0,6-2.7,6-6C12,2.6,9.3,0,6,0C6.1,0,6,0,6,0L6,0z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M5.6,7.8c0.3-0.2,0.6-0.2,0.9,0c0.8,0.5,2.3,1.4,2.3,1.4S9,9.3,9.1,9.3s0.2,0,0.2-0.1L8.8,7.9 c0,0-0.7-1.6-1-2.4C7.5,4.8,6.5,2.4,6.2,1.8c0-0.1-0.1-0.2-0.2-0.2S5.8,1.7,5.8,1.8C5.5,2.5,2.9,8.7,2.9,8.7S2.7,9,2.7,9.1 s-0.1,0.1,0,0.2s0.2,0,0.2,0L5.6,7.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationCircle);
export default __webpack_public_path__ + "static/media/location_circle.5354f053851786ccd0c5f325c1e38e3b.svg";
export { ForwardRef as ReactComponent };